import ExcelJS from "exceljs";

// Xuất "Phân công chuyên môn" của 1 tuần ra Excel theo ĐÚNG mẫu sheet "PCCM BG" của file
// "GiaoVien/THPT - PHÂN CÔNG.xlsx": tiêu đề 2 dòng, header ở dòng 5 (A..S), mỗi dòng 1 (GV, bộ môn),
// cột Khối 12/11/10 liệt kê lớp nối bằng " + ", số tiết theo khối, tổng, và Chủ nhiệm lớp 12/11/10.
const SUBJECT_ABBR = {
  "Toán": "Toán", "Ngữ văn": "Văn", "Lịch sử": "Sử", "Địa lý": "Địa", "Vật lý": "Lý", "Vật lí": "Lý",
  "Sinh học": "Sinh", "Hóa học": "Hóa", "Công nghệ": "CN", "GDKT&PL": "GDKTPL", "Tiếng anh": "Anh",
};
const SUBJECT_ORDER = ["Toán", "Ngữ văn", "Lịch sử", "Địa lý", "Vật lý", "Vật lí", "Sinh học", "Hóa học", "Công nghệ", "GDKT&PL"];
const SKIP_SUBJECTS = new Set(["HĐTN(SH)", "HĐTN(CC)"]);
const KHOIS = ["12", "11", "10"];
const khoiOf = (name) => (String(name || "").match(/^(\d+)/) || [])[1] || "";
const lastWord = (name) => String(name || "").trim().split(/\s+/).pop() || "";
const isBlocked = () => /FBAN|FBAV|Zalo|Messenger|Instagram/i.test(navigator.userAgent || "");

function toDate(s) {
  const m = String(s || "").match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
  if (m) return new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3])));
  const n = String(s || "").match(/^(\d{1,2})[/\-.](\d{1,2})[/\-.](\d{4})/);
  if (n) return new Date(Date.UTC(Number(n[3]), Number(n[2]) - 1, Number(n[1])));
  return s || "";
}

// classes: [{id,name,homeroomTeacherId}], subjects: [{id,name}], staffAll: [{id,name,dob,cccd,phone,employmentType}],
// effective: { classId: { subjectId: { assignedTeacherId, periodsPerWeek } } } — PCCM đã gộp riêng tuần.
export async function exportPccmByWeekExcel({ weekLabel, classes, subjects, staffAll, effective }) {
  const subjectById = Object.fromEntries(subjects.map((s) => [s.id, s]));
  const staffById = Object.fromEntries(staffAll.map((s) => [s.id, s]));
  const classById = Object.fromEntries(classes.map((c) => [c.id, c]));
  const cmp = (a, b) => String(a).localeCompare(String(b), "vi", { numeric: true });

  // (teacherId, subjectName) -> { khoi: [classNames], periods: {khoi: n} }
  const groups = {};
  Object.entries(effective || {}).forEach(([classId, subMap]) => {
    const cls = classById[classId]; if (!cls) return;
    Object.entries(subMap || {}).forEach(([subjectId, cfg]) => {
      const subj = subjectById[subjectId]; if (!subj || SKIP_SUBJECTS.has(subj.name)) return;
      const tid = cfg && cfg.assignedTeacherId; if (!tid) return;
      const k = `${subj.name}\u0001${tid}`;
      const g = (groups[k] = groups[k] || { subject: subj.name, tid, byKhoi: {}, periods: {} });
      const kh = khoiOf(cls.name);
      (g.byKhoi[kh] = g.byKhoi[kh] || []).push(cls.name);
      g.periods[kh] = (g.periods[kh] || 0) + (Number(cfg.periodsPerWeek) || 0);
    });
  });
  const homeroomOf = {}; // tid -> {khoi: [classNames]}
  classes.forEach((c) => { if (c.homeroomTeacherId) { const h = (homeroomOf[c.homeroomTeacherId] = homeroomOf[c.homeroomTeacherId] || {}); (h[khoiOf(c.name)] = h[khoiOf(c.name)] || []).push(c.name); } });

  const subjectNames = [...new Set(Object.values(groups).map((g) => g.subject))];
  const ordered = [
    ...SUBJECT_ORDER.filter((n) => subjectNames.includes(n)),
    ...subjectNames.filter((n) => !SUBJECT_ORDER.includes(n) && n !== "Tiếng anh").sort(cmp),
  ];
  const withAnh = subjectNames.includes("Tiếng anh");

  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet("PCCM BG");
  const widths = [8.3, 20.6, 15.4, 34.4, 21.6, 19.3, 17.6, 14.7, 18, 27.7, 73.3, 34, 26.1, 14, 14, 16, 18, 18, 18];
  widths.forEach((w, i) => { ws.getColumn(i + 1).width = w; });
  const font = { name: "Times New Roman", size: 13 };
  const thin = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };

  ws.mergeCells("A2:D2");
  ws.getCell("A2").value = "SỞ GIÁO DỤC VÀ ĐÀO TẠO HÀ NỘI \nTRƯỜNG TRUNG CẤP KINH TẾ - KỸ THUẬT PHAN CHU TRINH";
  ws.getCell("A2").font = { ...font, bold: true };
  ws.getCell("A2").alignment = { horizontal: "center", vertical: "middle", wrapText: true };
  ws.getRow(2).height = 45;
  ws.getCell("A3").value = `PHÂN CÔNG CHUYÊN MÔN KHỐI 12, 11, 10. ${String(weekLabel || "").toUpperCase()}`;
  ws.getCell("A3").font = { ...font, bold: true };

  const header = ["STT", "BỘ MÔN", "BỘ MÔN RÚT GỌN", "HỌ VÀ TÊN GV", "HỌ VÀ TÊN GV, BỘ MÔN RÚT GỌN", "Ngày sinh", "Số CCCD", "", "SĐT",
    "Khối 12", "Khối 11", "Khối 10", "Số tiết lớp 12", "Số tiết lớp 11", "Số tiết lớp 10", "Tổng số tiết /tuần", "Chủ nhiệm lớp 12", "Chủ nhiệm lớp 11", "Chủ nhiệm 10"];
  const hr = ws.getRow(5);
  header.forEach((h, i) => { const c = hr.getCell(i + 1); c.value = h; c.font = { ...font, bold: true }; c.alignment = { horizontal: "center", vertical: "middle", wrapText: true }; c.border = thin; c.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFFFF" } }; });
  hr.height = 34;

  let rowNo = 6;
  const gvcnWritten = new Set();
  const writeRow = (vals) => {
    const r = ws.getRow(rowNo++);
    vals.forEach((v, i) => { const c = r.getCell(i + 1); c.value = v === undefined ? "" : v; c.font = font; c.border = thin; c.alignment = { vertical: "middle", wrapText: true, horizontal: i === 0 ? "center" : undefined }; });
    if (vals[5] instanceof Date) r.getCell(6).numFmt = "dd/mm/yyyy";
    return r;
  };
  const rowFor = (stt, subjName, g, st) => {
    const abbr = SUBJECT_ABBR[subjName] || subjName;
    const hr_ = homeroomOf[g.tid] || {};
    const first = !gvcnWritten.has(g.tid); gvcnWritten.add(g.tid);
    const list = (kh) => (g.byKhoi[kh] || []).sort(cmp).join(" + ");
    const p = (kh) => g.periods[kh] || "";
    const total = KHOIS.reduce((s, kh) => s + (g.periods[kh] || 0), 0);
    writeRow([stt, subjName, abbr, st ? st.name : g.tid, st ? `${abbr.toUpperCase()}-${lastWord(st.name).toUpperCase()}` : "",
      st && st.dob ? toDate(st.dob) : "", st && st.cccd ? String(st.cccd) : "", st && st.employmentType ? st.employmentType : "", st && st.phone ? String(st.phone) : "",
      list("12"), list("11"), list("10"), p("12"), p("11"), p("10"), total || "",
      first ? (hr_["12"] || []).sort(cmp).join(" + ") : "", first ? (hr_["11"] || []).sort(cmp).join(" + ") : "", first ? (hr_["10"] || []).sort(cmp).join(" + ") : ""]);
  };
  const emitSubject = (subjName) => {
    const rows = Object.values(groups).filter((g) => g.subject === subjName)
      .map((g) => ({ g, st: staffById[g.tid] }))
      .sort((a, b) => (((a.st && a.st.employmentType) === "Thỉnh giảng") - ((b.st && b.st.employmentType) === "Thỉnh giảng")) || cmp(a.st ? a.st.name : a.g.tid, b.st ? b.st.name : b.g.tid));
    rows.forEach((x, i) => rowFor(i + 1, subjName, x.g, x.st));
  };
  ordered.forEach(emitSubject);
  // Phòng đào tạo: người chủ nhiệm nhưng không có tiết dạy môn nào trong PCCM tuần này
  const teachingTids = new Set(Object.values(groups).map((g) => g.tid));
  const pdt = Object.keys(homeroomOf).filter((tid) => !teachingTids.has(tid)).map((tid) => ({ tid, st: staffById[tid] })).sort((a, b) => cmp(a.st ? a.st.name : a.tid, b.st ? b.st.name : b.tid));
  pdt.forEach((x, i) => {
    const hr_ = homeroomOf[x.tid]; const st = x.st;
    writeRow([i + 1, "Phòng đào tạo", "PĐT", st ? st.name : x.tid, st ? `PĐT-${lastWord(st.name).toUpperCase()}` : "", st && st.dob ? toDate(st.dob) : "", st && st.cccd ? String(st.cccd) : "", st && st.employmentType ? st.employmentType : "", st && st.phone ? String(st.phone) : "",
      "", "", "", "", "", "", "", (hr_["12"] || []).sort(cmp).join(" + "), (hr_["11"] || []).sort(cmp).join(" + "), (hr_["10"] || []).sort(cmp).join(" + ")]);
  });
  if (withAnh) emitSubject("Tiếng anh");
  rowNo += 1;
  const sign = ws.getCell(`D${rowNo}`); sign.value = "Người phân công"; sign.font = { ...font, bold: true };
  ws.views = [{ state: "frozen", xSplit: 4, ySplit: 5 }];

  if (isBlocked()) { window.alert("Trình duyệt trong ứng dụng (Zalo/Messenger/...) không cho phép tải file.\n\nHãy mở bằng Safari/Chrome rồi bấm Export Excel lại."); return; }
  const buf = await wb.xlsx.writeBuffer();
  const blob = new Blob([buf], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `PCCM_${String(weekLabel || "tuan").replace(/[\\/:*?"<>|]+/g, "-").replace(/\s+/g, "_")}.xlsx`;
  document.body.appendChild(a); a.click(); document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
